import { Injectable } from "@angular/core";
import { IndPhrase } from "@shared/models/cat.model";
import { AnchorResult, CopiedAnchorResult, ReferenceIssue, ReferencePhrase } from "@shared/models/common";
import { EmbeddedObjectAnnotation } from "@shared/models/embedded-object-annotation";
import { RevRule } from "@shared/models/rev.model";


@Injectable({
  providedIn: 'root'
})export class CopyAnchorsCoordinatorService  {


    hasAnchor(anchor: AnchorResult, workingRefAnchors: AnchorResult[]): boolean {
        

        return workingRefAnchors?.find((phraseAnchor) => phraseAnchor.refDocAnchorId === anchor.refDocAnchorId && phraseAnchor.refDocId === anchor.refDocId) !== undefined;
    }
    canCopyAnchors(workingRefAnchors: AnchorResult[], catMatchRefAnchors: AnchorResult[]): boolean {

        if (!workingRefAnchors) {
            return true;
        }
        for (let i=0; i<catMatchRefAnchors.length; i++) {
            
            const currAnchor: AnchorResult = catMatchRefAnchors[i];
            const foundAnchorIndex = workingRefAnchors.findIndex((anchor) => anchor.refDocAnchorId == currAnchor.refDocAnchorId && anchor.refDocId == currAnchor.refDocId);
            if (foundAnchorIndex == -1) {
                return true;
            }
        }

        return false;

    }
    copyAnchor(anchor: AnchorResult, workingRefAnchors: AnchorResult[], phrase: IndPhrase | RevRule) {

        if (!workingRefAnchors) {
            workingRefAnchors = [];
        }
        
        let copiedAnchor: AnchorResult;
        // user removed from left side, but not saved yet
        let copiedEmbeddedObjectAnnotation = new EmbeddedObjectAnnotation();
        copiedEmbeddedObjectAnnotation.copy(anchor.embeddedObjectAnnotation);
        if (phrase.consistencyIssuesToUpdate.remove?.phrase_reference_consistency_check_results?.length > 0) {

            const index = phrase.consistencyIssuesToUpdate.remove.phrase_reference_consistency_check_results.findIndex((elem) => elem.ref_doc_id == anchor.refDocId && elem.ref_doc_anchor_id == anchor.refDocAnchorId);
            //not found anchor -> copy to left side

            if (index == -1) {

                copiedAnchor = new CopiedAnchorResult(anchor.issueId, anchor.refDocAnchorId, anchor.refDocId, copiedEmbeddedObjectAnnotation);
                this.addAnchor(anchor, phrase);
            } else {

                // deleted on left side, returning to left side as regular anchor
                copiedAnchor = new AnchorResult(phrase.consistencyIssuesToUpdate.remove.phrase_reference_consistency_check_results[index].issue_id, anchor.refDocAnchorId, anchor.refDocId, copiedEmbeddedObjectAnnotation)
                phrase.consistencyIssuesToUpdate.remove.phrase_reference_consistency_check_results.splice(index, 1);
            }

        } else {

                copiedAnchor = new CopiedAnchorResult(anchor.issueId, anchor.refDocAnchorId, anchor.refDocId, copiedEmbeddedObjectAnnotation);
                this.addAnchor(anchor, phrase);

        }
        workingRefAnchors.push(copiedAnchor);
        
    }


    copyNotExistingAnchors(workingRefAnchors: AnchorResult[], matchedAnchors: AnchorResult[], phrase: IndPhrase | RevRule) {

        for (let anchor of matchedAnchors) {
                        
            if (!this.hasAnchor(anchor, workingRefAnchors)) {
                
                this.copyAnchor(anchor, workingRefAnchors, phrase);
            }
            
        }
        
    }
    copyReferenceToWorkingPhrase(phrase: IndPhrase | RevRule, catMatchReference: ReferencePhrase, referenceIssue: ReferenceIssue | null) {
            
            let workingReference = this.createWorkingReferenceFromCatMatch(catMatchReference);
            if (!phrase.references) {
                
                phrase.references = [];
            }
            phrase.references.push(workingReference);
            
            if (referenceIssue != null) {
                // existing reference issue corresponds to the copied reference, so we update the reference issue to point to the new working reference
                referenceIssue.refPhraseId = workingReference.refPhraseId;
                referenceIssue.refFinding = 'COPIED_ANCHOR_REFERENCE';

            }
            phrase.consistencyIssuesToUpdate.is_ref_consistent_anchor_update_only = false;
            return workingReference;
    }
    createWorkingReferenceFromCatMatch(catMatchReference: ReferencePhrase) {

        let newReference = new ReferencePhrase();
        newReference.newSw = true;
        newReference.refType = 'REFERENCE';
        newReference.phraseId = 0;
        newReference.showInTile = true;
        newReference.showAnchors = true;
        newReference.isConsistencyGenerated = catMatchReference.isConsistencyGenerated;
        newReference.refPhraseId = catMatchReference.refPhraseId;
        newReference.refDocId = catMatchReference.refDocId;
        newReference.refPhraseText = catMatchReference.refPhraseText;
        newReference.anchors = [];
        return newReference;
    }
    private addAnchor(anchor: AnchorResult, phrase: IndPhrase | RevRule) {
            if (!phrase.consistencyIssuesToUpdate.add.phrase_reference_consistency_check_results) {
                
                phrase.consistencyIssuesToUpdate.add.phrase_reference_consistency_check_results = [];
            }
            phrase.consistencyIssuesToUpdate.add.phrase_reference_consistency_check_results.push({
                issue_id: null,
                ref_doc_id: anchor.refDocId,
                ref_doc_anchor_id: anchor.refDocAnchorId,
                ref_doc_anchor_path: anchor.embeddedObjectAnnotation.anchorPath
            })
    }

}